import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import POLineDetailModal from './POLineDetailModal';

/**
 * Opens the line a notification names (`?line=<id>`, optionally `&lineTab=`)
 * where the tenant has switched the PO Lines tab off.
 *
 * POLinesTab is what normally reads that link, so with the tab hidden the page
 * fell back to its default tab and the record never opened: every line-level
 * email landed on a list. The link is consumed on close, so a closed record
 * stays closed. The line endpoint is scoped, so a line the viewer may not see
 * gets the modal's own error state and no data.
 *
 * @link POLinesTab for the same link on a tenant that shows the tab.
 */
export default function LineDeepLinkModal() {
  const { user } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('line') ?? '';
  if (!/^\d+$/.test(raw)) return null;

  const lineId = Number(raw);
  const close = () => {
    const next = new URLSearchParams(searchParams);
    next.delete('line');
    next.delete('lineTab');
    setSearchParams(next, { replace: true });
  };

  return (
    <POLineDetailModal
      key={lineId}
      lineId={lineId}
      isOpen
      onClose={close}
      userType={user?.platform === 'SUPPLIER' ? 'supplier' : 'customer'}
      initialTab={searchParams.get('lineTab') || undefined}
    />
  );
}
